import React from 'react';
import { NavLink } from 'react-router-dom';

const items = [
  { to: '/profile',          label: 'Account',  icon: 'fa-user',           end: true },
  { to: '/profile/credits',  label: 'Credits',  icon: 'fa-coins',          end: false },
  { to: '/api-keys',         label: 'API Keys', icon: 'fa-key',            end: false },
  { to: '/profile/security', label: 'Security', icon: 'fa-shield-halved',  end: false },
];

const ProfileNav: React.FC = () => (
  <nav className="mb-6 flex flex-wrap gap-1 border-b border-gray-800">
    {items.map(({ to, label, icon, end }) => (
      <NavLink
        key={to}
        to={to}
        end={end}
        className={({ isActive }) =>
          `flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-colors border-b-2 -mb-px ${
            isActive
              ? 'text-white border-crypto-accent'
              : 'text-gray-400 border-transparent hover:text-white hover:border-gray-700'
          }`
        }
      >
        <i className={`fas ${icon} text-xs`}></i>
        {label}
      </NavLink>
    ))}
  </nav>
);

export default ProfileNav;
